import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from "@ngx-translate/core";
import {MatSnackBarModule} from "@angular/material/snack-bar";
import {CardOverlayModule} from "@pages/user/partials/card-overlay/card-overlay.module";
import {ParticipantDetailCardComponent} from "@pages/user/partials/participant-detail-card/participant-detail-card.component";
import {RouterModule} from "@angular/router";
import {LoaderModule} from "@shared/loader/loader.module";


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    MatSnackBarModule,
    CardOverlayModule,
    LoaderModule
  ],
  declarations: [ParticipantDetailCardComponent],
  exports: [ParticipantDetailCardComponent],
  providers: []
})
export class ParticipantDetailCardModule { }
